export default {
  // Quotation Management
  quotationManagement: {
    title: 'Quotation Management',
    description: 'Manage customer quotations and quotation process',

    // Tabs
    tabs: {
      fcl: 'FCL Quotation',
      lcl: 'LCL Quotation',
      air: 'Air Freight Quotation',
      precarriage: 'Precarriage Quotation',
      oncarriage: 'Oncarriage Quotation'
    },
    status: {
      success: 'Import Success',
      failed: 'Import Failed',
      pending: 'Pending Quote',
      quoted: 'Quoted',
      notEnabled: 'Not Enabled',
      rejected: 'Rejected',
      unlimited: 'Unlimited'
    },
    labels: {
      importStats: 'Import Details',
      successCount: 'Success Count',
      failedCount: 'Failed Count',
      priceNo: 'Rate No.',
      route: 'Route',
      validity: 'Validity',
      surchargeResult: 'Surcharge Result',
      updated: 'Updated',
      added: 'Added',
      overwrite: 'Overwrite',
      addNew: 'Add New',
      origin: 'Origin',
      destination: 'Destination',
      oceanSurcharge: 'Ocean Freight Surcharge',
      originSurcharge: 'Origin Surcharge',
      destinationSurcharge: 'Destination Surcharge'
    },

    // Toolbar buttons
    toolbar: {
      addQuotation: 'New Quotation',
      addFclQuotation: 'New FCL Quotation',
      addPrePortQuotation: 'New Pre-port Inquiry',
      addLastMileQuotation: 'New Last Mile Inquiry',
      batchOperations: 'Batch Operations ({count})',
      batchExport: 'Batch Export',
      batchExportExcel: 'Batch Export Excel',
      batchExportCsv: 'Batch Export CSV',
      batchDelete: 'Batch Delete'
    },

    // Table column headers
    columns: {
      quotationNo: 'Quotation No.',
      inquiryNo: 'Inquiry No.',
      source: 'Quotation Source',
      quoterId: 'Quoter',
      inquiryCreatedBy: 'Inquirer',
      inquirySubmitDate: 'Inquiry Date',
      quotationStatus: 'Quotation Status',
      supplierName: 'Supplier',
      selection: 'Selection',
      prePortQuotationStatus: 'First-leg Quotation Status',
      trunkLineQuotationStatus: 'Main-leg Quotation Status',
      lastMileQuotationStatus: 'Last-mile Quotation Status',
      validPeriod: 'Valid Period',
      submitDate: 'Submit Date',
      seaEq: 'Container Type & Quantity',
      cargoReadyTime: 'Cargo Ready Time',
      palletNature: 'Cargo Nature',
      carrierId: 'Carrier',
      directTransit: 'Direct/Transit',
      routeId: 'Route',
      loadingPortId: 'Port of Loading',
      dischargingPortId: 'Port of Discharge',
      destinationPortId: 'Destination Port',
      cargoType: 'Cargo Type',
      weight: 'Weight(KGS)',
      cubage: 'Volume(CBM)',
      etd: 'ETD',
      eta: 'ETA',
      serviceTerm: 'Service Term',
      clientType: 'Client Type',
      clientTitle: 'Client Name',
      remarks: 'Remarks',
      createdBy: 'Created By',
      dateCreated: 'Created Time',
      modifiedBy: 'Modified By',
      dateModified: 'Modified Time',
      actions: 'Actions'
    },

    // Action buttons
    actions: {
      view: 'View',
      detail: 'Details',
      edit: 'Edit',
      submit: 'Submit',
      revoke: 'Revoke',
      delete: 'Delete',
      more: 'More',
      copy: 'Copy',
      importRate: 'Import Rate',
      viewRate: 'View Rate',
      viewLater: 'View Later'
    },

    // Confirmation dialogs
    confirmDialog: {
      submitTitle: 'Confirm Submit',
      submitContent: 'Are you sure to submit quotation "{quotationNo}"?',
      submitOk: 'Confirm Submit',
      submitCancel: 'Cancel',
      revokeTitle: 'Confirm Revoke',
      revokeContent: 'Are you sure to revoke quotation "{quotationNo}" to draft status?',
      revokeOk: 'Confirm Revoke',
      revokeCancel: 'Cancel',
      deleteTitle: 'Confirm Delete',
      deleteContent: 'Are you sure to delete quotation "{quotationNo}"?',
      batchDeleteTitle: 'Batch Delete Confirmation',
      batchDeleteContent: 'Are you sure to delete the selected {count} records?'
    },

    // Messages
    messages: {
      dataLoadFailed: 'Failed to load FCL quotation data',
      selectRecordsFirst: 'Please select records to delete first',
      noDataToExport: 'No data to export',
      exportSuccess: 'Successfully exported {count} records as {type} format',
      exportFailed: 'Failed to export {type} format, please try again later',
      submitSuccess: 'Quotation submitted successfully',
      submitFailed: 'Submit failed, please try again later',
      revokeSuccess: 'Quotation has been revoked to draft status',
      revokeFailed: 'Revoke failed, please try again later',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      copySuccess: 'Copy successful',
      copyFailed: 'Copy failed, please try again later',
      batchDeleteSuccess: 'Batch delete successful',
      batchDeleteFailed: 'Batch delete failed',
      alreadyDraft: 'Quotation is already in draft status, no need to revoke',
      onlySubmittedCanRevoke: 'Only submitted quotations can be revoked to draft',
      invalidStatusForAction: 'Invalid quotation status',
      cannotDeleteRecords: 'Submitted quotations or quotations automatically created from inquiries cannot be deleted, please check the selected records',
      inquiryNotFound: 'Inquiry record not found',
      viewInquiryFailed: 'Failed to view inquiry',
      importRateSuccess: 'Import Success',
      importRateSuccessDesc: 'Successfully created rate draft, you can view and edit it in Ocean FCL Rate maintenance.',
      importRateSuccessDescShort: 'Quotation data written to rate maintenance, surcharges synced to surcharge management',
      markupAutoMatching: 'Markup rules matching, sales price will be calculated automatically...',
      importRateFailed: 'Import Rate failed, please check if quotation data is complete',
      importCancelSuccess: 'Import cancelled and data cleaned up',
      importCancelFailed: 'Failed to cancel import',
      surchargeConflictModal: {
        title: 'Surcharge Conflict',
        message: 'The following fees already exist in current rates with different amounts. Confirm to overwrite?',
        alert: 'The following fees already exist in surcharge management and will be processed automatically:',
        columns: {
          surchargeType: 'Surcharge Type',
          feeName: 'Fee Name',
          oldValue: 'Original Price',
          newValue: 'New Price (Quoted)',
          actionType: 'Action'
        },
        actionTypes: {
          overwrite: 'Overwrite',
          new: 'Add New'
        },
        footerNote: {
          line1: '· Existing fee lines: Overwrite with prices from the quotation',
          line2: '· New fee lines: Directly add to surcharge management module',
          line3: '· Deleted fee lines: Surcharge module remains unchanged, manual processing required'
        },
        actions: {
          confirmImport: 'Confirm Import'
        }
      }
    },

    // Custom table modal
    customTableModal: {
      title: 'Custom Table Fields',
      description: 'Select fields to display in the table',
      resetButton: 'Reset'
    },

    // Export
    export: {
      filename: 'Quotation Data'
    }
  },

  // Quotation Detail Page
  quotationDetail: {
    // Page titles
    pageTitle: {
      create: 'New Quotation',
      edit: 'Quotation Detail',
      view: 'Quotation Detail',
      loading: 'Loading...'
    },

    // Form sections
    sections: {
      basicInfo: 'Basic Information',
      cargoInfo: 'Cargo Information',
      loadingPoint: 'Loading Point',
      deliveryAddress: 'Last Mile Delivery Address',
      containerInfo: 'Container Type & Quantity',
      fclPrice: 'FCL Prices',
      prePortPrice: 'Preport Prices',
      lastMilePrice: 'Last Mile Prices',
      priceDetail: 'Price Details',
      trunkLinePrice: 'Trunk Line Price',
      addTrunkLinePrice: 'Add Trunk Line Price',
      addPrePortPrice: 'Add Preport Price',
      addLastMilePrice: 'Add Last Mile Price',
      rejectQuote: 'Reject Quote',
      rejectReason: 'Please input the reason for rejection',
      feeDetail: 'Fee Details',
      nonContainerFeeItem: 'Non-Container Fee Item',
      containerFeeItem: 'Container Fee Item',
      addNonContainerFeeItem: 'Add Non-Container Fee Item',
      addContainerFeeItem: 'Add Container Fee Item'
    },

    // Checkbox options
    checkboxes: {
      prePortPrice: 'Preport Price',
      trunkLinePrice: 'Trunk Line Price',
      lastMilePrice: 'Last Mile Price'
    },

    // Action buttons
    actions: {
      saveDraft: 'Save Draft',
      exportQuotation: 'Export Quotation',
      submit: 'Submit',
      cancel: 'Cancel',
      back: 'Back',
      delete: 'Delete',
      confirmReject: 'Confirm Reject',
      confirmQuote: 'Confirm Quote',
      revokeQuote: 'Revoke Quote',
      aiRecognition: 'AI Recognition',
      addContainerType: 'Add Container Type',
      bookingNow: 'Book Now'
    },

    // Temporary Markup (view-only, not persisted)
    tempMarkup: {
      action: 'Temp Markup',
      modalTitle: 'Set Temporary Markup',
      feeItem: 'Fee Item',
      boxType: 'Box Type',
      originalPrice: 'Original Price',
      amountLabel: 'Temporary markup amount (negative for discount)',
      amountPlaceholder: 'Enter markup amount',
      tipsSignRule: 'Tip: Positive = markup, Negative = discount',
      adjustedPrice: 'Adjusted Price',
      importantNotes: 'Important Notes:',
      note1: 'Temporary markup is for quotation view only and will not alter source data',
      note2: 'Adjusted price will be shown as "original ± markup" in the table',
      note3: 'You can modify or clear the temporary markup anytime',
      saveSuccess: 'Temporary markup saved',
      saveFailed: 'Failed to save temporary markup',
      clearSuccess: 'Temporary markup cleared',
      clearFailed: 'Failed to clear temporary markup'
    },

    // Basic information fields
    basicInfo: {
      quotationNo: 'Quotation No.',
      inquiryNo: 'Inquiry No.',
      quoterId: 'Quoter',
      inquiryCreatedBy: 'Inquirer',
      inquirySubmitDate: 'Inquiry Date',
      submitDate: 'Submit Date',
      palletNature: 'Pallet Nature',
      cargoReadyTime: 'Cargo Ready Time',
      client: 'Client',
      detailAddress: 'Detail Address',
      inquiryEnterprise: 'Inquiry Enterprise'
    },

    // Cargo information fields
    cargoInfo: {
      directTransit: 'Direct/Transit',
      route: 'Route',
      loadingPort: 'Loading Port',
      destinationPort: 'Destination Port',
      dischargingPort: 'Discharging Port',
      transitPort1: 'Transit Port (1st)',
      transitPort2: 'Transit Port (2nd)',
      transitPort3: 'Transit Port (3rd)',
      quantity: 'Quantity',
      weight: 'Weight',
      dimensions: 'Dimensions',
      containerRequirement: 'Container Requirement',
      transportTerms: 'Transport Terms',
      cargoValue: 'Cargo Value',
      cargoValueCurrency: 'Currency',
      carrier: 'Carrier',
      routeCode: 'Route Code',
      vessel: 'Vessel',
      voyage: 'Voyage',
      sailingSchedule: 'Sailing Schedule',
      priceValidity: 'Price Validity',
      freeTime: 'Free Time',
      direct: 'Direct',
      transit: 'Transit',
      transitPort: 'Transit Port',
      remarks: 'Remarks'
    },

    // Tip Texts
    tips: {
      autoUppercase: 'Automatic Uppercase for English letters'
    },

    // Loading point fields
    loadingPoint: {
      selectArea: 'Select Loading Point Area',
      province: 'Province',
      city: 'City',
      district: 'District',
      street: 'Street/Town',
      detailAddress: 'Detail Address',
      administrativeDivision: 'Administrative Division',
      detailedLocation: 'Detailed Location'
    },

    // Delivery address fields
    deliveryAddress: {
      addressInfo: 'Delivery Address Information',
      addressType: 'Delivery Address Type',
      postalCodeAndCountry: 'Postal Code & Country',
      country: 'Select country',
      postalCode: 'Enter or select postal code',
      provinceCity: 'Province/State/City',
      province: 'Province/State',
      city: 'City',
      district: 'District',
      detailAddress: 'Detail Address',
      amazonWarehouse: 'Amazon Warehouse Selection',
      ecangWarehouse: 'Ecang Warehouse Selection',
      thirdPartyAddress: 'Third Party Address'
    },

    // Container information fields
    containerInfo: {
      containerType: 'Container Type',
      quantity: 'Quantity',
      containerTypeAndQuantity: 'Container Type & Quantity: ',
      rfTemperatureRequirement: 'Temperature Requirement',
      rfVentilationRequirement: 'Ventilation Requirement',
      temperatureRange: 'Enter temperature range, e.g.: -20 to 30',
      temperatureStart: 'Start Temperature',
      temperatureEnd: 'End Temperature',
      ventilationDoor: 'Ventilation Door',
      ventilationOpen: 'Open',
      ventilationClose: 'Close',
      ventilationVolume: 'Air Flow',
      ventilationVolumeUnit: 'CBM/H',
      ventilationVolumePlaceholder: 'Enter air flow',
      temperatureUnit: '℃',
      temperatureTo: 'to'
    },

    // Placeholder texts
    placeholders: {
      autoGenerate: 'Auto Generate',
      selectPalletNature: 'Select pallet nature',
      selectCargoReadyTimeRange: 'Select cargo ready time range',
      selectCargoReadyDate: 'Select cargo ready date',
      selectOption: 'Please select',
      inputServiceTerm: 'Enter service term',
      selectClientType: 'Select client type',
      selectClient: 'Select client',
      inputClientTitle: 'Enter client title',
      selectRoute: 'Select route',
      selectLoadingPort: 'Select loading port',
      selectDestinationPort: 'Select destination port',
      selectDischargingPort: 'Select discharging port',
      selectTransitPort1: 'Select first transit port',
      selectTransitPort2: 'Select second transit port',
      selectTransitPort3: 'Select third transit port',
      enterInputQuantity: 'Enter quantity',
      inputWeight: 'Enter weight',
      inputDimensions: 'Enter dimensions',
      selectContainerRequirement: 'Select container requirement',
      selectTransportTerms: 'Select transport terms',
      inputCargoValue: 'Enter cargo value',
      selectCargoValueCurrency: 'Select currency',
      selectCarrier: 'Select carrier',
      inputRemarks: 'Enter remarks',
      province: 'Province',
      city: 'City',
      district: 'District',
      street: 'Street/Town',
      inputDetailAddress: 'Enter detail address',
      selectCountry: 'Select country',
      inputPostalCode: 'Enter or select postal code',
      inputDeliveryAddress: 'Enter detail address',
      selectAmazonWarehouse: 'Select Amazon warehouse',
      selectEcangWarehouse: 'Select Ecang warehouse',
      selectContainerType: 'Select container type',
      inputQuantity: 'Quantity',
      inputLoadingPointAddress: 'Enter loading point address',
      inputDeliveryAddressText: 'Enter delivery address',
      noFclPrices: 'No FCL prices',
      noPrePortPrices: 'No Preport prices',
      noLastMilePrices: 'No Last mile prices',
      quotePending: 'Quote pending',
      quoteRejected: 'Quote rejected',
      rejectReason: 'Please input the reason for rejection...',
      rejectReminder: 'Note: After rejecting the quote, it cannot be edited again.',
      noFeeDetail: 'No fee details, please add fee items',
      noPriceDetail: 'No price details, please click the button above to add',
      selectValidPeriod: 'Select valid period',
      selectBeginDate: 'Select start date',
      selectEndDate: 'Select end date',
      selectDirectFlag: 'Select direct/transit',
      inputVoyageDays: 'Enter voyage days',
      inputDetentionFreeDays: 'Enter detention free days',
      inputDemurrageFreeDays: 'Enter demurrage free days',
      selectFeeName: 'Select fee name',
      autoFill: 'Auto fill',
      inputPrice: 'Enter price',
      inputUnitRate: 'Enter unit rate',
      selectBillingUnit: 'Select billing unit',
      selectPriceMethod: 'Select price method',
      selectMeasureMethod: 'Select measure method',
      inputSupplier: 'Enter supplier',
      inputAgentName: 'Enter agent name',
      selectBranchLine: 'Select branch line',
      selectSeaRail: 'Select sea rail',
      inputRouteCode: 'Please input route code',
      inputVessel: 'Please input vessel name',
      inputVoyageNo: 'Please input voyage number',
      inputVoyage: 'Please enter valid voyage days',
      inputFreeTime: 'Please input free time days',
      selectTransitPort: 'Please select transit port'
    },

    // Units and suffixes
    units: {
      kilogram: 'KGS'
    },

    // AI recognition modal
    aiModal: {
      loadingPointTitle: 'AI Smart Address Recognition',
      deliveryTitle: 'AI Smart Address Recognition',
      loadingPointDesc: 'Please paste the address information into the text box below:',
      deliveryDesc: 'Please paste the US address information into the text box below:',
      loadingPointTip: 'Tip: The system will automatically parse province, city, district and street information, detail address will be filled into the detail address field',
      deliveryRules: 'Recognition Rules:',
      deliveryRule1: 'If contains Amazon warehouse code (ONT8/BFI4 etc.), will be set as Amazon warehouse type',
      deliveryRule2: 'If contains Ecang code (LAX203/ATL205 etc.), will be set as Ecang type',
      deliveryRule3: 'Other cases will be set as third-party address, and parse address and postal code',
      recognize: 'Recognize',
      cancel: 'Cancel'
    },

    // Dropdown options
    options: {
      alibaba: 'Alibaba Group',
      jd: 'JD Logistics Co., Ltd.',
      huawei: 'Huawei Technologies Co., Ltd.',
      xiaomi: 'Xiaomi Corporation',
      haier: 'Haier Group Corporation',
      baosteel: 'Baosteel Group Corporation Limited',
      cmg: 'China Merchants Group',
      cosco: 'COSCO SHIPPING Holdings'
    },

    // Messages
    messages: {
      saveDraftSuccess: 'Draft saved successfully',
      updateSuccess: 'Quote updated successfully',
      submitSuccess: 'Quote submitted successfully',
      saveFailed: 'Save failed',
      submitFailed: 'Submit failed',
      exportPending: 'Export rate function under development...',
      addressRecognitionSuccess: 'Address recognition successful',
      inputAddressFirst: 'Please enter address information',
      confirmSubmit: 'Confirm to submit quotation?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      loading: 'Loading...',
      noData: 'No data',
      copySuccess: 'Text copied to clipboard',
      copyFailed: 'Copy failed, please copy manually',
      noAvailablePrices: 'No available quotation found. Please add and select quotations.',
      selectQuotedPriceFirst: 'Please select a quoted price first',
      rejectQuoteSuccess: 'Quote rejected successfully',
      rejectQuoteFailed: 'Quote rejection failed',
      rejectReasonEmpty: 'Reject reason cannot be empty',
      failedToGetQuotationText: 'Failed to get quotation text content',
      noFeeDataForTrial: 'No fee data available for cost trial',
      feeItemNotFound: 'Fee item not found. Please refresh and try again',
      bookNowFailed: 'Failed to confirm booking',
      loadTemplateFailed: 'Failed to load template',
      openTemplateViewReportFailed: 'Failed to open template view report',
      quotationAllDisabled: 'At least one of trunk line, pre-port and last mile prices must be enabled',
      confirmQuoteSuccess: 'Quote confirmed successfully',
      confirmQuoteFailed: 'Quote confirmation failed',
      revokeQuoteSuccess: 'Quote revoked successfully',
      revokeQuoteFailed: 'Quote revocation failed',
      confirmRevoke: 'Confirm Revoke',
      confirmRevokeContent: 'Are you sure you want to revoke this segment quote? After revocation, the segment will return to pending status.',
      cannotRevokeAfterOrder: 'This quotation has been converted to an order and cannot be revoked',
      noPriceWarning: 'Please add rate solution first',
      feeRefactorInProgress: 'Fee details loading...',
      invalidVoyage: 'Please enter a valid voyage',
      etaBeforeEtd: 'ETA cannot be earlier than ETD',
      feeNameRequired: 'Fee name is required'
    },

    // Validation Messages
    validation: {
      transshipmentPortRequired: 'Transit port is required when Transit is selected',
      oceanPriceRequired: 'Please fill in the ocean freight price for all container types',
      oceanCurrencyRequired: 'Please select the currency for Ocean Freight',
      surchargePriceRequired: 'Please fill in the price for all container types of fee item [{name}]',
      surchargeUnitPriceRequired: 'Please fill in the unit rate of fee item [{name}]',
      surchargeCurrencyRequired: 'Please select the currency for fee item [{name}]',
      priceValidityRequired: 'Please select price validity period',
      clientRequired: 'Please select a client',
      salesBranchRequired: 'Please select a sales branch'
    },

    // Fee Category Related
    oceanFreight: 'Ocean Freight',
    perContainerPrice: 'Per Container Price',
    originCharges: 'Origin Charges',
    destCharges: 'Dest Charges',
    potentialCharges: 'Potential Charges',
    potentialChargesTip: 'Potential costs, not included in the total price for now',
    addOceanSurcharge: 'Add Ocean Surcharge',
    addOriginCharge: 'Add Origin Charge',
    addDestCharge: 'Add Dest Charge',
    addPotentialCharge: 'Add Potential Charge',
    prepaid: 'Prepaid',
    collect: 'Collect',
    perContainer: 'Per Container',
    perBill: 'Per Bill',
    containerType: 'Container Type',

    // Export quotation modal
    exportQuotationModal: {
      title: 'Export Quotations',
      containerTypeAndQuantity: 'Container Type & Quantity',
      copyQuotationText: 'Copy Quick Quotation Text',
      printQuotation: 'Print Quotation Document',
      printPending: 'Print function under development'
    },

    // Quick quotation text modal
    quotationTextModal: {
      title: 'Quick Quotation Text',
      description: 'The following is the quotation text generated based on your selected container types and quantities. You can copy and send it to customers:',
      placeholder: 'Please enter quotation text',
      close: 'Close',
      copyText: 'Copy Text'
    },

    // Quotation text content (Note: quotationText content is identical to inquiryDetail.quotationText)
    quotationText: {
      title: '【Inquiry Quotations】',
      inquiryNo: 'Inquiry No.: ',
      inquiryType: 'Inquiry Type: ',
      fcl: 'FCL',
      prePort: 'Pre port',
      lastMile: 'Last mile',
      inquirer: 'Inquirer: ',
      containerTypeAndQuantity: 'Container Type & Quantity: ',
      routeInfo: 'Route Information: ',
      loadingPort: 'Loading Port: ',
      destinationPort: 'Destination Port: ',
      carrier: 'Carrier: ',
      directTransit: 'Direct/Transit: ',
      priceDetails: 'Price Details: ',
      trunkLineFee: 'Trunk Line Fee: ',
      prePortFee: 'Pre-port Fee: ',
      lastMileFee: 'Last Mile Fee: ',
      feeCalculation: 'Fee Calculation: ',
      trunkLine: 'Trunk Line: ',
      cargoReadyTime: 'Cargo Ready Time: ',
      client: 'Client: ',
      remarks: 'Remarks: ',
      priceDisclaimer: '※ The above prices are for reference only, actual prices are subject to formal contracts',
      contactInfo: '※ If you have any questions, please contact our customer service team',
      notSpecified: 'Not Specified',
      containerCharges: 'Container Charges: ',
      otherCharges: 'Other Charges: '
    },

    // Price display labels
    priceDisplay: {
      priceNo: 'Price No',
      carrierName: 'Carrier',
      validPeriod: 'Valid Period',
      directTransit: 'Direct/Transit',
      direct: 'Direct',
      transit: 'Transit',
      voyageDays: 'Voyage Days',
      days: 'day(s)',
      detentionFreeDays: 'Free Detention Days',
      demurrageFreeDays: 'Free Demurrage Days',
      containerCharges: 'Container Charges',
      otherCharges: 'Other Charges',
      supplier: 'Supplier',
      priceMethod: 'Price Method',
      agentName: 'Agent Name'
    },

    // ZIP code related
    zipCode: {
      loading: 'Loading...',
      loadProvincesFailed: 'Failed to load provinces',
      loadCitiesFailed: 'Failed to load cities',
      loadDistrictsFailed: 'Failed to load districts',
      loadStreetsFailed: 'Failed to load streets',
      loadZipCodesFailed: 'Failed to load postal codes',
      zipCodeQueryFailed: 'Postal code query failed',
      zipCodeLoadSuccess: 'China postal codes loaded successfully',
      loadContainerTypesFailed: 'Failed to load container types',
      containerTypesLoadSuccess: 'Container types loaded successfully'
    },

    // Table columns
    columns: {
      feeName: 'Fee Name',
      currency: 'Currency',
      unitRate: 'Unit Rate',
      measure: 'Measure',
      remarks: 'Remarks',
      actions: 'Actions',
      voyageDays: 'Voyage Days',
      detentionFreeDays: 'Free Detention Days',
      demurrageFreeDays: 'Free Demurrage Days'
    },

    // Supplier Quotation Detail Special (Match template path)
    supplierQuotationDetail: {
      voyageInfo: 'Voyage Information',
      supplierRemarks: 'Supplier Remarks',
      feeDetails: 'Fee Details',
      oceanFreight: 'Ocean Freight',
      perContainerPrice: 'Per Container Price',
      originCharges: 'Origin Charges',
      destCharges: 'Dest Charges',
      potentialCharges: 'Potential Charges',
      potentialChargesTip: 'Potential costs, not included in the total price for now',
      addOceanSurcharge: 'Add Ocean Surcharge',
      addOriginCharge: 'Add Origin Charge',
      addDestCharge: 'Add Dest Charge',
      addPotentialCharge: 'Add Potential Charge',
      prepaid: 'Prepaid',
      collect: 'Collect',
      perContainer: 'Per Container',
      perBill: 'Per Bill',
      containerType: 'Container Type',
      unitPrice: 'Unit Price',
      quantity: 'Quantity',
      unit: 'Unit',
      amount: 'Amount',
      currency: 'Currency',
      project: 'Project',
      remarks: 'Remarks',
      addItem: 'Add Item',
      feeType: 'Fee Category',
      feeTypes: {
        0: 'Basic Ocean Freight',
        1: 'Ocean Surcharge',
        2: 'Origin Charges',
        3: 'Dest Charges',
        4: 'Potential Charges'
      },
      currentVersion: 'Current Version',
      noConsultationRecords: 'No consultation records',
      changeContent: 'Change Content',
      consultationRemarks: 'Consultation Remarks',
      consultationHistory: 'Consultation History',
      quotationDetail: 'Quotation Detail',
      confirmConsultation: 'Confirm Consultation',
      cancel: 'Cancel',
      save: 'Save',
      submit: 'Submit Quote',
      edit: 'Edit'
    }
  }
}
